export const getDiscountsSupportedKey = (contextId: string, productTypeId: string) =>
  `${contextId}-${productTypeId}`;
